<template>
<div id='login-main'  class="calf" v-cloak>
    <!--  -->
    <div id='header'>
        <img class="logoImg" src="https://hpublic-zw.obs.cn-south-1.myhuaweicloud.com/anycubic-hlogo.png" alt="" />
        <div @mouseenter='enter' @mouseleave='leave' v-show='!login.hideHelpdesk'>
            <i class='help icon-help'></i>
            <!-- 热线 -->
            <div class='customer-tip' style="height:216px" v-if='isPop'>
                <div class='triangle-up'></div>
                <p class='tip-head'>
                    <span>产品经理</span>
                </p>
                <div>
                    <p class="line">商品、设置、订单 ：杨盼盼 </p>
                    <p class="line">客服：刘先俊 </p>
                    <p class="line">头程：龙梦华 </p>
                    <p class="line">库存、报表：吴颖 </p>
                </div>
            </div>
        </div>
        <i class='collect icon-collect' v-show='!login.hideFavorite' @click='openCollect' title='添加到收藏夹'></i>
        <!-- 收藏 -->
        <div class='message-model' v-show='isCollect'>
            <div class='model-title'>
                <h5>消息</h5>
                <i class='icon-close close' @click='closeCollect'></i>
            </div>
            <div class='model-body'>
                <i class='icon-alternate-info wln-icon-info'></i>
                <em>{{messageInfo}}</em>
            </div>
            <div class='model-footer'>
                <button class='close-btn' @click='closeCollect'>关闭</button>
            </div>
        </div>
    </div>

    <div class='main'>
        <div class='login-box' v-if='!isChooseCompany && !isValidate'>
            <div class='title'>欢迎使用纵维立方业务中台</div>
            <div class='error-message' :style="{visibility: [isError ? 'visible' : 'hidden']}">{{errorMsg}}</div>
            <div class='form-login'>
                <div class='default-input'>
                    <i class="iconfont icon-phone icon" :class="[isUser ? 'icon-active' : '']"></i>
                    <input type="text" autocomplete='on' v-model='user' @focus='userFocus($event)'
                            @blur='isUser = false'
                            placeholder="请输入手机号/邮箱">
                </div>
                <div class='default-input' v-show='mode === 1'>
                    <i class="iconfont icon-password icon" :class="[isPwd ? 'icon-active' : '']"></i>
                    <input type="password" v-model='password' @focus='pwdFocus($event)' @blur='isPwd = false'
                            placeholder="密码">
                </div>
                <div class='img-validate' v-show="count > 2 || mode === 0 ">
                    <input type="text" placeholder="验证码" v-model='imgCode'>
                    <img v-if="imgUrl" :src="imgUrl" @click='changeImgCode' alt="">
                </div>
                <div class='login-btn' @click='submit'>
                    <button>
                        <span v-show='!loading'>登录</span>
                        <span v-show='loading' class='default-loading icon-loading' style='font-size: 30px;'></span>
                    </button>
                </div>
                <!-- <div class='login-btn' @click='keycloakLogin'>
                    <button>
                        <span v-show='!loading'>Keycloak 登录</span>
                        <span v-show='loading' class='default-loading icon-loading' style='font-size: 30px;'></span>
                    </button>
                </div> -->
            </div>
        </div>
    </div>

    <div class="footer">
        <p class="copyright">
            版权所有 © 2022 ANYCUBIC 3D Printing . All Rights Reserved.粤ICP备17062658号
            <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"><span style="color: rgb(169, 169, 169);"></span></a>
        </p>
    </div>
</div>
</template>
  
<script>
import {login} from '@/api/login'
import '@/assets/styles/login.css' // global css
import keycloak from '@/utils/keycloak.js'

export default {
    name: 'login',
    components: {},
    data() {
        return{
        login: {
            logo: '',
            hotline: null,
            copyright: null,
            icpbei: null,
            hideHelpdesk: false,
            hideFavorite: false
        },
        banner: [{
            url: '//hupun.com/product/pos.html',
            image: "//www.hupun.com/img/erp/erp-20190612.jpg"
        }],
        headColor: "#ffffff",
        messageInfo: '请按下快捷键：CTRL+D，添加到收藏夹！',
        // 登录错误信息
        isError: false,
        errorMsg: null,
        // 登录方式
        mode: 1,
        modeTxt: "验证码登录",
        user: "",
        password: null,
        code: null,
        imgCode: null,
        count: 0, // 验证次数，超过3次触发图片验证码
        isSend: false,
        time: 60,
        isChooseCompany: false,
        loading: false,
        users: [], // 公司列表
        // 帮助与收藏
        hotline: null,
        isPop: false,
        onOff: false,
        isCollect: false,
        //控制input图标
        isUser: false,
        isPwd: false,
        isCode: false,
        // 短信验证
        isValidate: false,
        validateCode: null,
        codeError: "您此次登录存在风险，需要账号验证身份！",
        validateTxt: "发送验证码",
        // 图片验证码
        imgUrl: null,
        adminUser: null,
        isIP: false, // 如果出现验证是否是ip验证
        adminList: [],
        selectOpen: false,
        companyID: null,
        oldErpDomain: null,
        duration: 3,
        tempTime: 3,
        blindMonkUrl: null,
        isBlindMonk: false,
        kefuLink: null,
        fastChoose: false, // 单公司或记录上次登录公司触发切换
        // 续费弹框
        dialogVisible: false,
    }
    },
    watch: {
        // 'user': {
        //     handler(v){
        //     this.user = v.trim()
        //     }
        // }
    },
    created() {
        const parts = window.location.href.split('=').filter(Boolean);
		if(parts[1]){
			localStorage.setItem('token',parts[1]);
            this.$router.replace(`/`) 
		} else {
          // 有token的时候直接跳转首页
            if(localStorage.getItem('token')){
                this.$router.replace(`/`) 
            }
        }
        // this.user = this.getCookie('account');
    },
    mounted() {
        var _this = this;
        this.$nextTick(function () {
            document.onkeydown = function (e) {
                e = e || window.event;
                if (e.keyCode == 13) {
                    _this.submit()
                }
            }
        })
    },
    methods: {
        leave: function () {
            var _this = this;
            this.onOff = false;
            var timer = setTimeout(function () {
                clearTimeout(timer);
                if (!_this.onOff) _this.isPop = false
            }, 300)
        },
        enter: function () {
            var _this = this;
            this.onOff = true;
            var timer = setTimeout(function () {
                _this.isPop = true;
                clearTimeout(timer)
            }, 300)
        },
        userFocus: function (event) {
            this.isUser = true;
            event.currentTarget.select()
        },
        pwdFocus: function (event) {
            this.isPwd = true;
            event.currentTarget.select()
        },
        openCollect: function () {
            this.headColor = "#f6f6f6";
            this.messageInfo = '请按下快捷键：CTRL+D，添加到收藏夹！';
            this.isCollect = true
        },
        closeCollect: function () {
            this.headColor = "#ffffff";
            this.isCollect = false
        },
        // 截取错误信息
        subMessage: function (msg) {
            if (msg.length > 100) {
                return msg.slice(0, 100)
            }
            return msg
        },

        
        // getCookie: function (cname) {
        //     var name = cname + "=";
        //     var ca = document.cookie.split(';');
        //     for (var i = 0; i < ca.length; i++) {
        //         var c = ca[i].trim();
        //         if (c.indexOf(name) == 0) {
        //             return c.substring(name.length, c.length);
        //         }
        //     }
        //     return "";
        // },
        
        // setCookie: function (name, value) {
            
        // },

        // 更换图片验证码
        changeImgCode: function () {
            this.imgUrl = "/service/captcha/generate?time=" + Date.now() + "&refresh=true"
        },

        // 埋点
        blindMonk: function (message) {
            axios({
                method: 'get',
                baseURL: this.blindMonkUrl,
                url: '/blindmonk/log',
                withCredentials: true,
                params: {
                    key: 'erp.login',
                    time: new Date().getTime(),
                    duration: this.duration,
                    session: this.user,
                    err: message
                }
            }).then(function (res) {
                console.log(res)
            }).catch(function (err) {
                console.log(err)
            })
        },

        validateTelUtil: function (phoneNumber) {
            var CtelReg = /^\d*$/; // 全数字
            // 邮箱
            var pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (phoneNumber.indexOf("@") === -1) {
                if (phoneNumber.replace(/\s+/g, "").length < 1) {
                    return true
                }
                if(!CtelReg.test(phoneNumber)){
                    return true
                }
            } else {
                if (!pattern.test(phoneNumber)) {
                    return true
                }
            }
            return false
        },

        userSort: function (user) {
            var arr = [];
            var arrNo = [];
            for (var i = 0; i < user.length; i++) {
                if (user[i].application.expired) {
                    arr.push(user[i])
                } else {
                    arrNo.push(user[i])
                }
            }
            return [].concat(arrNo, arr);
        },

        // 登录 密码1, 验证码0
        submit: function () {
            if (!this.user) {
                this.isError = true;
                this.errorMsg = "请输入手机或邮箱";
                return
            } 
            else {
                this.isError = false;
            }
            if (this.mode === 1) {
                this.isError = true;
                if (!this.password) {
                    this.errorMsg = "请输入密码";
                    return
                } else this.isError = false
            } else {
                if (!this.code) {
                    this.isError = true;
                    this.errorMsg = "请输入验证码";
                    return
                } else this.isError = false
            }
            // 图片验证码填写验证
            if (this.count >= 3) {
                if (!this.imgCode) {
                    this.isError = true;
                    this.errorMsg = "请输入图片验证码";
                    return
                } else this.isError = false
            }
            this.loading = true;

            var query = {
                account: this.user,
                password: this.password,
            };
            var _this = this

            login(query).then((res) => {
                _this.loading = false;
                localStorage.clear();
                localStorage.setItem('token',res)
                this.$router.replace(`/`,()=>{})
            }).catch((err)=>{
                console.log(err);
                _this.errorMsg = err.message;
                _this.loading = false;
                _this.isError = true;
            })
        },
        // keycloak登录
        keycloakLogin() {
            keycloak.login()
        },

    }

}
</script>

<style scoped>
#login-main{
    height: 100vh;
}
 #login-main #header{
    background-color: none !important;
}
.icon {
    display: block;
    position: absolute;
    left: 1px;
    border-radius: 4px 0 0 4px;
    opacity: 1;
    color: #d0d0d0;
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 22px;
    text-align: center;
    border-right: 1px solid rgba(34, 36, 38, 0.15);
}

.icon-active {
    color: #878787;
}

</style>